/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PaymentRouteImport } from './routes/payment'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as LoginRouteImport } from './routes/login'
import { Route as EkycRouteImport } from './routes/ekyc'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as EkycResultRouteImport } from './routes/ekyc/result'
import { Route as DashboardSimDistributionIndexRouteImport } from './routes/_dashboard/sim-distribution/index'
import { Route as DashboardSearchIndexRouteImport } from './routes/_dashboard/search/index'
import { Route as DashboardPortoutRequestsIndexRouteImport } from './routes/_dashboard/portout-requests/index'
import { Route as DashboardOwnershipTransferIndexRouteImport } from './routes/_dashboard/ownership-transfer/index'
import { Route as DashboardNttpcMaintenancesIndexRouteImport } from './routes/_dashboard/nttpc-maintenances/index'
import { Route as DashboardIdentificationsIndexRouteImport } from './routes/_dashboard/identifications/index'
import { Route as DashboardDeliveryRequestsIndexRouteImport } from './routes/_dashboard/delivery-requests/index'
import { Route as DashboardContinuousPaymentPortoutRequestsIndexRouteImport } from './routes/_dashboard/continuous-payment-portout-requests/index'
import { Route as DashboardContinuousPaymentConfirmationIndexRouteImport } from './routes/_dashboard/continuous-payment-confirmation/index'
import { Route as DashboardClientsIndexRouteImport } from './routes/_dashboard/clients/index'
import { Route as DashboardCallDetailsIndexRouteImport } from './routes/_dashboard/call-details/index'
import { Route as DashboardBlacklistingRequestsIndexRouteImport } from './routes/_dashboard/blacklisting-requests/index'
import { Route as DashboardBillingIndexRouteImport } from './routes/_dashboard/billing/index'
import { Route as DashboardBillingManagementIndexRouteImport } from './routes/_dashboard/billing-management/index'
import { Route as PaymentCardRegisterTokenRouteImport } from './routes/payment/card-register/$token'
import { Route as EkycSuccessClientIdRouteImport } from './routes/ekyc/success.$clientId'
import { Route as EkycErrorClientIdRouteImport } from './routes/ekyc/error.$clientId'
import { Route as DashboardPortoutRequestsNewRouteImport } from './routes/_dashboard/portout-requests/new'
import { Route as DashboardPortoutRequestsCancelRouteImport } from './routes/_dashboard/portout-requests/cancel'
import { Route as DashboardDeliveryRequestsCreateRouteImport } from './routes/_dashboard/delivery-requests/create'
import { Route as DashboardContinuousPaymentPortoutRequestsNewRouteImport } from './routes/_dashboard/continuous-payment-portout-requests/new'
import { Route as DashboardContinuousPaymentPortoutRequestsCancelRouteImport } from './routes/_dashboard/continuous-payment-portout-requests/cancel'
import { Route as DashboardClientsCreateRouteImport } from './routes/_dashboard/clients/create'
import { Route as DashboardBlacklistingRequestsNewRouteImport } from './routes/_dashboard/blacklisting-requests/new'
import { Route as DashboardClientsClientIdIndexRouteImport } from './routes/_dashboard/clients/$clientId/index'
import { Route as DashboardDeliveryRequestsIdShippingHistoryRouteImport } from './routes/_dashboard/delivery-requests/$id.shipping-history'
import { Route as DashboardClientsClientIdSimBindingRouteImport } from './routes/_dashboard/clients/$clientId/sim-binding'
import { Route as DashboardClientsClientIdInvoicesIndexRouteImport } from './routes/_dashboard/clients/$clientId/invoices/index'
import { Route as DashboardClientsClientIdInvoicesInvoiceIdRouteImport } from './routes/_dashboard/clients/$clientId/invoices/$invoiceId'
import { Route as DashboardClientsClientIdIdentificationReuploadRouteImport } from './routes/_dashboard/clients/$clientId/identification/reupload'
import { Route as DashboardClientsClientIdIdentificationEditRouteImport } from './routes/_dashboard/clients/$clientId/identification/edit'
import { Route as DashboardClientsClientIdCorporateInfoEditRouteImport } from './routes/_dashboard/clients/$clientId/corporate-info/edit'
import { Route as DashboardClientsClientIdIdentificationHistoriesHistoryIdRouteImport } from './routes/_dashboard/clients/$clientId/identification/histories/$historyId'

const PaymentRoute = PaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const EkycRoute = EkycRouteImport.update({
  id: '/ekyc',
  path: '/ekyc',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const EkycResultRoute = EkycResultRouteImport.update({
  id: '/result',
  path: '/result',
  getParentRoute: () => EkycRoute,
} as any)
const DashboardSimDistributionIndexRoute =
  DashboardSimDistributionIndexRouteImport.update({
    id: '/sim-distribution/',
    path: '/sim-distribution/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSearchIndexRoute = DashboardSearchIndexRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPortoutRequestsIndexRoute =
  DashboardPortoutRequestsIndexRouteImport.update({
    id: '/portout-requests/',
    path: '/portout-requests/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardOwnershipTransferIndexRoute =
  DashboardOwnershipTransferIndexRouteImport.update({
    id: '/ownership-transfer/',
    path: '/ownership-transfer/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardNttpcMaintenancesIndexRoute =
  DashboardNttpcMaintenancesIndexRouteImport.update({
    id: '/nttpc-maintenances/',
    path: '/nttpc-maintenances/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardIdentificationsIndexRoute =
  DashboardIdentificationsIndexRouteImport.update({
    id: '/identifications/',
    path: '/identifications/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDeliveryRequestsIndexRoute =
  DashboardDeliveryRequestsIndexRouteImport.update({
    id: '/delivery-requests/',
    path: '/delivery-requests/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContinuousPaymentPortoutRequestsIndexRoute =
  DashboardContinuousPaymentPortoutRequestsIndexRouteImport.update({
    id: '/continuous-payment-portout-requests/',
    path: '/continuous-payment-portout-requests/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContinuousPaymentConfirmationIndexRoute =
  DashboardContinuousPaymentConfirmationIndexRouteImport.update({
    id: '/continuous-payment-confirmation/',
    path: '/continuous-payment-confirmation/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsIndexRoute = DashboardClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCallDetailsIndexRoute =
  DashboardCallDetailsIndexRouteImport.update({
    id: '/call-details/',
    path: '/call-details/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBlacklistingRequestsIndexRoute =
  DashboardBlacklistingRequestsIndexRouteImport.update({
    id: '/blacklisting-requests/',
    path: '/blacklisting-requests/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBillingIndexRoute = DashboardBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBillingManagementIndexRoute =
  DashboardBillingManagementIndexRouteImport.update({
    id: '/billing-management/',
    path: '/billing-management/',
    getParentRoute: () => DashboardRoute,
  } as any)
const PaymentCardRegisterTokenRoute =
  PaymentCardRegisterTokenRouteImport.update({
    id: '/card-register/$token',
    path: '/card-register/$token',
    getParentRoute: () => PaymentRoute,
  } as any)
const EkycSuccessClientIdRoute = EkycSuccessClientIdRouteImport.update({
  id: '/success/$clientId',
  path: '/success/$clientId',
  getParentRoute: () => EkycRoute,
} as any)
const EkycErrorClientIdRoute = EkycErrorClientIdRouteImport.update({
  id: '/error/$clientId',
  path: '/error/$clientId',
  getParentRoute: () => EkycRoute,
} as any)
const DashboardPortoutRequestsNewRoute =
  DashboardPortoutRequestsNewRouteImport.update({
    id: '/portout-requests/new',
    path: '/portout-requests/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardPortoutRequestsCancelRoute =
  DashboardPortoutRequestsCancelRouteImport.update({
    id: '/portout-requests/cancel',
    path: '/portout-requests/cancel',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDeliveryRequestsCreateRoute =
  DashboardDeliveryRequestsCreateRouteImport.update({
    id: '/delivery-requests/create',
    path: '/delivery-requests/create',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContinuousPaymentPortoutRequestsNewRoute =
  DashboardContinuousPaymentPortoutRequestsNewRouteImport.update({
    id: '/continuous-payment-portout-requests/new',
    path: '/continuous-payment-portout-requests/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContinuousPaymentPortoutRequestsCancelRoute =
  DashboardContinuousPaymentPortoutRequestsCancelRouteImport.update({
    id: '/continuous-payment-portout-requests/cancel',
    path: '/continuous-payment-portout-requests/cancel',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsCreateRoute = DashboardClientsCreateRouteImport.update({
  id: '/clients/create',
  path: '/clients/create',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBlacklistingRequestsNewRoute =
  DashboardBlacklistingRequestsNewRouteImport.update({
    id: '/blacklisting-requests/new',
    path: '/blacklisting-requests/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdIndexRoute =
  DashboardClientsClientIdIndexRouteImport.update({
    id: '/clients/$clientId/',
    path: '/clients/$clientId/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDeliveryRequestsIdShippingHistoryRoute =
  DashboardDeliveryRequestsIdShippingHistoryRouteImport.update({
    id: '/delivery-requests/$id/shipping-history',
    path: '/delivery-requests/$id/shipping-history',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdSimBindingRoute =
  DashboardClientsClientIdSimBindingRouteImport.update({
    id: '/clients/$clientId/sim-binding',
    path: '/clients/$clientId/sim-binding',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdInvoicesIndexRoute =
  DashboardClientsClientIdInvoicesIndexRouteImport.update({
    id: '/clients/$clientId/invoices/',
    path: '/clients/$clientId/invoices/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdInvoicesInvoiceIdRoute =
  DashboardClientsClientIdInvoicesInvoiceIdRouteImport.update({
    id: '/clients/$clientId/invoices/$invoiceId',
    path: '/clients/$clientId/invoices/$invoiceId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdIdentificationReuploadRoute =
  DashboardClientsClientIdIdentificationReuploadRouteImport.update({
    id: '/clients/$clientId/identification/reupload',
    path: '/clients/$clientId/identification/reupload',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdIdentificationEditRoute =
  DashboardClientsClientIdIdentificationEditRouteImport.update({
    id: '/clients/$clientId/identification/edit',
    path: '/clients/$clientId/identification/edit',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdCorporateInfoEditRoute =
  DashboardClientsClientIdCorporateInfoEditRouteImport.update({
    id: '/clients/$clientId/corporate-info/edit',
    path: '/clients/$clientId/corporate-info/edit',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdIdentificationHistoriesHistoryIdRoute =
  DashboardClientsClientIdIdentificationHistoriesHistoryIdRouteImport.update({
    id: '/clients/$clientId/identification/histories/$historyId',
    path: '/clients/$clientId/identification/histories/$historyId',
    getParentRoute: () => DashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/ekyc': typeof EkycRouteWithChildren
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/payment': typeof PaymentRouteWithChildren
  '/ekyc/result': typeof EkycResultRoute
  '/': typeof DashboardIndexRoute
  '/blacklisting-requests/new': typeof DashboardBlacklistingRequestsNewRoute
  '/clients/create': typeof DashboardClientsCreateRoute
  '/continuous-payment-portout-requests/cancel': typeof DashboardContinuousPaymentPortoutRequestsCancelRoute
  '/continuous-payment-portout-requests/new': typeof DashboardContinuousPaymentPortoutRequestsNewRoute
  '/delivery-requests/create': typeof DashboardDeliveryRequestsCreateRoute
  '/portout-requests/cancel': typeof DashboardPortoutRequestsCancelRoute
  '/portout-requests/new': typeof DashboardPortoutRequestsNewRoute
  '/ekyc/error/$clientId': typeof EkycErrorClientIdRoute
  '/ekyc/success/$clientId': typeof EkycSuccessClientIdRoute
  '/payment/card-register/$token': typeof PaymentCardRegisterTokenRoute
  '/billing-management': typeof DashboardBillingManagementIndexRoute
  '/billing': typeof DashboardBillingIndexRoute
  '/blacklisting-requests': typeof DashboardBlacklistingRequestsIndexRoute
  '/call-details': typeof DashboardCallDetailsIndexRoute
  '/clients': typeof DashboardClientsIndexRoute
  '/continuous-payment-confirmation': typeof DashboardContinuousPaymentConfirmationIndexRoute
  '/continuous-payment-portout-requests': typeof DashboardContinuousPaymentPortoutRequestsIndexRoute
  '/delivery-requests': typeof DashboardDeliveryRequestsIndexRoute
  '/identifications': typeof DashboardIdentificationsIndexRoute
  '/nttpc-maintenances': typeof DashboardNttpcMaintenancesIndexRoute
  '/ownership-transfer': typeof DashboardOwnershipTransferIndexRoute
  '/portout-requests': typeof DashboardPortoutRequestsIndexRoute
  '/search': typeof DashboardSearchIndexRoute
  '/sim-distribution': typeof DashboardSimDistributionIndexRoute
  '/clients/$clientId/sim-binding': typeof DashboardClientsClientIdSimBindingRoute
  '/delivery-requests/$id/shipping-history': typeof DashboardDeliveryRequestsIdShippingHistoryRoute
  '/clients/$clientId': typeof DashboardClientsClientIdIndexRoute
  '/clients/$clientId/corporate-info/edit': typeof DashboardClientsClientIdCorporateInfoEditRoute
  '/clients/$clientId/identification/edit': typeof DashboardClientsClientIdIdentificationEditRoute
  '/clients/$clientId/identification/reupload': typeof DashboardClientsClientIdIdentificationReuploadRoute
  '/clients/$clientId/invoices/$invoiceId': typeof DashboardClientsClientIdInvoicesInvoiceIdRoute
  '/clients/$clientId/invoices': typeof DashboardClientsClientIdInvoicesIndexRoute
  '/clients/$clientId/identification/histories/$historyId': typeof DashboardClientsClientIdIdentificationHistoriesHistoryIdRoute
}
export interface FileRoutesByTo {
  '/ekyc': typeof EkycRouteWithChildren
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/payment': typeof PaymentRouteWithChildren
  '/ekyc/result': typeof EkycResultRoute
  '/': typeof DashboardIndexRoute
  '/blacklisting-requests/new': typeof DashboardBlacklistingRequestsNewRoute
  '/clients/create': typeof DashboardClientsCreateRoute
  '/continuous-payment-portout-requests/cancel': typeof DashboardContinuousPaymentPortoutRequestsCancelRoute
  '/continuous-payment-portout-requests/new': typeof DashboardContinuousPaymentPortoutRequestsNewRoute
  '/delivery-requests/create': typeof DashboardDeliveryRequestsCreateRoute
  '/portout-requests/cancel': typeof DashboardPortoutRequestsCancelRoute
  '/portout-requests/new': typeof DashboardPortoutRequestsNewRoute
  '/ekyc/error/$clientId': typeof EkycErrorClientIdRoute
  '/ekyc/success/$clientId': typeof EkycSuccessClientIdRoute
  '/payment/card-register/$token': typeof PaymentCardRegisterTokenRoute
  '/billing-management': typeof DashboardBillingManagementIndexRoute
  '/billing': typeof DashboardBillingIndexRoute
  '/blacklisting-requests': typeof DashboardBlacklistingRequestsIndexRoute
  '/call-details': typeof DashboardCallDetailsIndexRoute
  '/clients': typeof DashboardClientsIndexRoute
  '/continuous-payment-confirmation': typeof DashboardContinuousPaymentConfirmationIndexRoute
  '/continuous-payment-portout-requests': typeof DashboardContinuousPaymentPortoutRequestsIndexRoute
  '/delivery-requests': typeof DashboardDeliveryRequestsIndexRoute
  '/identifications': typeof DashboardIdentificationsIndexRoute
  '/nttpc-maintenances': typeof DashboardNttpcMaintenancesIndexRoute
  '/ownership-transfer': typeof DashboardOwnershipTransferIndexRoute
  '/portout-requests': typeof DashboardPortoutRequestsIndexRoute
  '/search': typeof DashboardSearchIndexRoute
  '/sim-distribution': typeof DashboardSimDistributionIndexRoute
  '/clients/$clientId/sim-binding': typeof DashboardClientsClientIdSimBindingRoute
  '/delivery-requests/$id/shipping-history': typeof DashboardDeliveryRequestsIdShippingHistoryRoute
  '/clients/$clientId': typeof DashboardClientsClientIdIndexRoute
  '/clients/$clientId/corporate-info/edit': typeof DashboardClientsClientIdCorporateInfoEditRoute
  '/clients/$clientId/identification/edit': typeof DashboardClientsClientIdIdentificationEditRoute
  '/clients/$clientId/identification/reupload': typeof DashboardClientsClientIdIdentificationReuploadRoute
  '/clients/$clientId/invoices/$invoiceId': typeof DashboardClientsClientIdInvoicesInvoiceIdRoute
  '/clients/$clientId/invoices': typeof DashboardClientsClientIdInvoicesIndexRoute
  '/clients/$clientId/identification/histories/$historyId': typeof DashboardClientsClientIdIdentificationHistoriesHistoryIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteWithChildren
  '/ekyc': typeof EkycRouteWithChildren
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/payment': typeof PaymentRouteWithChildren
  '/ekyc/result': typeof EkycResultRoute
  '/_dashboard/': typeof DashboardIndexRoute
  '/_dashboard/blacklisting-requests/new': typeof DashboardBlacklistingRequestsNewRoute
  '/_dashboard/clients/create': typeof DashboardClientsCreateRoute
  '/_dashboard/continuous-payment-portout-requests/cancel': typeof DashboardContinuousPaymentPortoutRequestsCancelRoute
  '/_dashboard/continuous-payment-portout-requests/new': typeof DashboardContinuousPaymentPortoutRequestsNewRoute
  '/_dashboard/delivery-requests/create': typeof DashboardDeliveryRequestsCreateRoute
  '/_dashboard/portout-requests/cancel': typeof DashboardPortoutRequestsCancelRoute
  '/_dashboard/portout-requests/new': typeof DashboardPortoutRequestsNewRoute
  '/ekyc/error/$clientId': typeof EkycErrorClientIdRoute
  '/ekyc/success/$clientId': typeof EkycSuccessClientIdRoute
  '/payment/card-register/$token': typeof PaymentCardRegisterTokenRoute
  '/_dashboard/billing-management/': typeof DashboardBillingManagementIndexRoute
  '/_dashboard/billing/': typeof DashboardBillingIndexRoute
  '/_dashboard/blacklisting-requests/': typeof DashboardBlacklistingRequestsIndexRoute
  '/_dashboard/call-details/': typeof DashboardCallDetailsIndexRoute
  '/_dashboard/clients/': typeof DashboardClientsIndexRoute
  '/_dashboard/continuous-payment-confirmation/': typeof DashboardContinuousPaymentConfirmationIndexRoute
  '/_dashboard/continuous-payment-portout-requests/': typeof DashboardContinuousPaymentPortoutRequestsIndexRoute
  '/_dashboard/delivery-requests/': typeof DashboardDeliveryRequestsIndexRoute
  '/_dashboard/identifications/': typeof DashboardIdentificationsIndexRoute
  '/_dashboard/nttpc-maintenances/': typeof DashboardNttpcMaintenancesIndexRoute
  '/_dashboard/ownership-transfer/': typeof DashboardOwnershipTransferIndexRoute
  '/_dashboard/portout-requests/': typeof DashboardPortoutRequestsIndexRoute
  '/_dashboard/search/': typeof DashboardSearchIndexRoute
  '/_dashboard/sim-distribution/': typeof DashboardSimDistributionIndexRoute
  '/_dashboard/clients/$clientId/sim-binding': typeof DashboardClientsClientIdSimBindingRoute
  '/_dashboard/delivery-requests/$id/shipping-history': typeof DashboardDeliveryRequestsIdShippingHistoryRoute
  '/_dashboard/clients/$clientId/': typeof DashboardClientsClientIdIndexRoute
  '/_dashboard/clients/$clientId/corporate-info/edit': typeof DashboardClientsClientIdCorporateInfoEditRoute
  '/_dashboard/clients/$clientId/identification/edit': typeof DashboardClientsClientIdIdentificationEditRoute
  '/_dashboard/clients/$clientId/identification/reupload': typeof DashboardClientsClientIdIdentificationReuploadRoute
  '/_dashboard/clients/$clientId/invoices/$invoiceId': typeof DashboardClientsClientIdInvoicesInvoiceIdRoute
  '/_dashboard/clients/$clientId/invoices/': typeof DashboardClientsClientIdInvoicesIndexRoute
  '/_dashboard/clients/$clientId/identification/histories/$historyId': typeof DashboardClientsClientIdIdentificationHistoriesHistoryIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/ekyc'
    | '/login'
    | '/maintenance'
    | '/payment'
    | '/ekyc/result'
    | '/'
    | '/blacklisting-requests/new'
    | '/clients/create'
    | '/continuous-payment-portout-requests/cancel'
    | '/continuous-payment-portout-requests/new'
    | '/delivery-requests/create'
    | '/portout-requests/cancel'
    | '/portout-requests/new'
    | '/ekyc/error/$clientId'
    | '/ekyc/success/$clientId'
    | '/payment/card-register/$token'
    | '/billing-management'
    | '/billing'
    | '/blacklisting-requests'
    | '/call-details'
    | '/clients'
    | '/continuous-payment-confirmation'
    | '/continuous-payment-portout-requests'
    | '/delivery-requests'
    | '/identifications'
    | '/nttpc-maintenances'
    | '/ownership-transfer'
    | '/portout-requests'
    | '/search'
    | '/sim-distribution'
    | '/clients/$clientId/sim-binding'
    | '/delivery-requests/$id/shipping-history'
    | '/clients/$clientId'
    | '/clients/$clientId/corporate-info/edit'
    | '/clients/$clientId/identification/edit'
    | '/clients/$clientId/identification/reupload'
    | '/clients/$clientId/invoices/$invoiceId'
    | '/clients/$clientId/invoices'
    | '/clients/$clientId/identification/histories/$historyId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/ekyc'
    | '/login'
    | '/maintenance'
    | '/payment'
    | '/ekyc/result'
    | '/'
    | '/blacklisting-requests/new'
    | '/clients/create'
    | '/continuous-payment-portout-requests/cancel'
    | '/continuous-payment-portout-requests/new'
    | '/delivery-requests/create'
    | '/portout-requests/cancel'
    | '/portout-requests/new'
    | '/ekyc/error/$clientId'
    | '/ekyc/success/$clientId'
    | '/payment/card-register/$token'
    | '/billing-management'
    | '/billing'
    | '/blacklisting-requests'
    | '/call-details'
    | '/clients'
    | '/continuous-payment-confirmation'
    | '/continuous-payment-portout-requests'
    | '/delivery-requests'
    | '/identifications'
    | '/nttpc-maintenances'
    | '/ownership-transfer'
    | '/portout-requests'
    | '/search'
    | '/sim-distribution'
    | '/clients/$clientId/sim-binding'
    | '/delivery-requests/$id/shipping-history'
    | '/clients/$clientId'
    | '/clients/$clientId/corporate-info/edit'
    | '/clients/$clientId/identification/edit'
    | '/clients/$clientId/identification/reupload'
    | '/clients/$clientId/invoices/$invoiceId'
    | '/clients/$clientId/invoices'
    | '/clients/$clientId/identification/histories/$historyId'
  id:
    | '__root__'
    | '/_dashboard'
    | '/ekyc'
    | '/login'
    | '/maintenance'
    | '/payment'
    | '/ekyc/result'
    | '/_dashboard/'
    | '/_dashboard/blacklisting-requests/new'
    | '/_dashboard/clients/create'
    | '/_dashboard/continuous-payment-portout-requests/cancel'
    | '/_dashboard/continuous-payment-portout-requests/new'
    | '/_dashboard/delivery-requests/create'
    | '/_dashboard/portout-requests/cancel'
    | '/_dashboard/portout-requests/new'
    | '/ekyc/error/$clientId'
    | '/ekyc/success/$clientId'
    | '/payment/card-register/$token'
    | '/_dashboard/billing-management/'
    | '/_dashboard/billing/'
    | '/_dashboard/blacklisting-requests/'
    | '/_dashboard/call-details/'
    | '/_dashboard/clients/'
    | '/_dashboard/continuous-payment-confirmation/'
    | '/_dashboard/continuous-payment-portout-requests/'
    | '/_dashboard/delivery-requests/'
    | '/_dashboard/identifications/'
    | '/_dashboard/nttpc-maintenances/'
    | '/_dashboard/ownership-transfer/'
    | '/_dashboard/portout-requests/'
    | '/_dashboard/search/'
    | '/_dashboard/sim-distribution/'
    | '/_dashboard/clients/$clientId/sim-binding'
    | '/_dashboard/delivery-requests/$id/shipping-history'
    | '/_dashboard/clients/$clientId/'
    | '/_dashboard/clients/$clientId/corporate-info/edit'
    | '/_dashboard/clients/$clientId/identification/edit'
    | '/_dashboard/clients/$clientId/identification/reupload'
    | '/_dashboard/clients/$clientId/invoices/$invoiceId'
    | '/_dashboard/clients/$clientId/invoices/'
    | '/_dashboard/clients/$clientId/identification/histories/$historyId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
  EkycRoute: typeof EkycRouteWithChildren
  LoginRoute: typeof LoginRoute
  MaintenanceRoute: typeof MaintenanceRoute
  PaymentRoute: typeof PaymentRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/payment': {
      id: '/payment'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof PaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ekyc': {
      id: '/ekyc'
      path: '/ekyc'
      fullPath: '/ekyc'
      preLoaderRoute: typeof EkycRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/ekyc/result': {
      id: '/ekyc/result'
      path: '/result'
      fullPath: '/ekyc/result'
      preLoaderRoute: typeof EkycResultRouteImport
      parentRoute: typeof EkycRoute
    }
    '/_dashboard/sim-distribution/': {
      id: '/_dashboard/sim-distribution/'
      path: '/sim-distribution'
      fullPath: '/sim-distribution'
      preLoaderRoute: typeof DashboardSimDistributionIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/search/': {
      id: '/_dashboard/search/'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof DashboardSearchIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/portout-requests/': {
      id: '/_dashboard/portout-requests/'
      path: '/portout-requests'
      fullPath: '/portout-requests'
      preLoaderRoute: typeof DashboardPortoutRequestsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/ownership-transfer/': {
      id: '/_dashboard/ownership-transfer/'
      path: '/ownership-transfer'
      fullPath: '/ownership-transfer'
      preLoaderRoute: typeof DashboardOwnershipTransferIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/nttpc-maintenances/': {
      id: '/_dashboard/nttpc-maintenances/'
      path: '/nttpc-maintenances'
      fullPath: '/nttpc-maintenances'
      preLoaderRoute: typeof DashboardNttpcMaintenancesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/identifications/': {
      id: '/_dashboard/identifications/'
      path: '/identifications'
      fullPath: '/identifications'
      preLoaderRoute: typeof DashboardIdentificationsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/delivery-requests/': {
      id: '/_dashboard/delivery-requests/'
      path: '/delivery-requests'
      fullPath: '/delivery-requests'
      preLoaderRoute: typeof DashboardDeliveryRequestsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/continuous-payment-portout-requests/': {
      id: '/_dashboard/continuous-payment-portout-requests/'
      path: '/continuous-payment-portout-requests'
      fullPath: '/continuous-payment-portout-requests'
      preLoaderRoute: typeof DashboardContinuousPaymentPortoutRequestsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/continuous-payment-confirmation/': {
      id: '/_dashboard/continuous-payment-confirmation/'
      path: '/continuous-payment-confirmation'
      fullPath: '/continuous-payment-confirmation'
      preLoaderRoute: typeof DashboardContinuousPaymentConfirmationIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/': {
      id: '/_dashboard/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof DashboardClientsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/call-details/': {
      id: '/_dashboard/call-details/'
      path: '/call-details'
      fullPath: '/call-details'
      preLoaderRoute: typeof DashboardCallDetailsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/blacklisting-requests/': {
      id: '/_dashboard/blacklisting-requests/'
      path: '/blacklisting-requests'
      fullPath: '/blacklisting-requests'
      preLoaderRoute: typeof DashboardBlacklistingRequestsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/billing/': {
      id: '/_dashboard/billing/'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof DashboardBillingIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/billing-management/': {
      id: '/_dashboard/billing-management/'
      path: '/billing-management'
      fullPath: '/billing-management'
      preLoaderRoute: typeof DashboardBillingManagementIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/payment/card-register/$token': {
      id: '/payment/card-register/$token'
      path: '/card-register/$token'
      fullPath: '/payment/card-register/$token'
      preLoaderRoute: typeof PaymentCardRegisterTokenRouteImport
      parentRoute: typeof PaymentRoute
    }
    '/ekyc/success/$clientId': {
      id: '/ekyc/success/$clientId'
      path: '/success/$clientId'
      fullPath: '/ekyc/success/$clientId'
      preLoaderRoute: typeof EkycSuccessClientIdRouteImport
      parentRoute: typeof EkycRoute
    }
    '/ekyc/error/$clientId': {
      id: '/ekyc/error/$clientId'
      path: '/error/$clientId'
      fullPath: '/ekyc/error/$clientId'
      preLoaderRoute: typeof EkycErrorClientIdRouteImport
      parentRoute: typeof EkycRoute
    }
    '/_dashboard/portout-requests/new': {
      id: '/_dashboard/portout-requests/new'
      path: '/portout-requests/new'
      fullPath: '/portout-requests/new'
      preLoaderRoute: typeof DashboardPortoutRequestsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/portout-requests/cancel': {
      id: '/_dashboard/portout-requests/cancel'
      path: '/portout-requests/cancel'
      fullPath: '/portout-requests/cancel'
      preLoaderRoute: typeof DashboardPortoutRequestsCancelRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/delivery-requests/create': {
      id: '/_dashboard/delivery-requests/create'
      path: '/delivery-requests/create'
      fullPath: '/delivery-requests/create'
      preLoaderRoute: typeof DashboardDeliveryRequestsCreateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/continuous-payment-portout-requests/new': {
      id: '/_dashboard/continuous-payment-portout-requests/new'
      path: '/continuous-payment-portout-requests/new'
      fullPath: '/continuous-payment-portout-requests/new'
      preLoaderRoute: typeof DashboardContinuousPaymentPortoutRequestsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/continuous-payment-portout-requests/cancel': {
      id: '/_dashboard/continuous-payment-portout-requests/cancel'
      path: '/continuous-payment-portout-requests/cancel'
      fullPath: '/continuous-payment-portout-requests/cancel'
      preLoaderRoute: typeof DashboardContinuousPaymentPortoutRequestsCancelRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/create': {
      id: '/_dashboard/clients/create'
      path: '/clients/create'
      fullPath: '/clients/create'
      preLoaderRoute: typeof DashboardClientsCreateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/blacklisting-requests/new': {
      id: '/_dashboard/blacklisting-requests/new'
      path: '/blacklisting-requests/new'
      fullPath: '/blacklisting-requests/new'
      preLoaderRoute: typeof DashboardBlacklistingRequestsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/': {
      id: '/_dashboard/clients/$clientId/'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof DashboardClientsClientIdIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/delivery-requests/$id/shipping-history': {
      id: '/_dashboard/delivery-requests/$id/shipping-history'
      path: '/delivery-requests/$id/shipping-history'
      fullPath: '/delivery-requests/$id/shipping-history'
      preLoaderRoute: typeof DashboardDeliveryRequestsIdShippingHistoryRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/sim-binding': {
      id: '/_dashboard/clients/$clientId/sim-binding'
      path: '/clients/$clientId/sim-binding'
      fullPath: '/clients/$clientId/sim-binding'
      preLoaderRoute: typeof DashboardClientsClientIdSimBindingRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/invoices/': {
      id: '/_dashboard/clients/$clientId/invoices/'
      path: '/clients/$clientId/invoices'
      fullPath: '/clients/$clientId/invoices'
      preLoaderRoute: typeof DashboardClientsClientIdInvoicesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/invoices/$invoiceId': {
      id: '/_dashboard/clients/$clientId/invoices/$invoiceId'
      path: '/clients/$clientId/invoices/$invoiceId'
      fullPath: '/clients/$clientId/invoices/$invoiceId'
      preLoaderRoute: typeof DashboardClientsClientIdInvoicesInvoiceIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/identification/reupload': {
      id: '/_dashboard/clients/$clientId/identification/reupload'
      path: '/clients/$clientId/identification/reupload'
      fullPath: '/clients/$clientId/identification/reupload'
      preLoaderRoute: typeof DashboardClientsClientIdIdentificationReuploadRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/identification/edit': {
      id: '/_dashboard/clients/$clientId/identification/edit'
      path: '/clients/$clientId/identification/edit'
      fullPath: '/clients/$clientId/identification/edit'
      preLoaderRoute: typeof DashboardClientsClientIdIdentificationEditRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/corporate-info/edit': {
      id: '/_dashboard/clients/$clientId/corporate-info/edit'
      path: '/clients/$clientId/corporate-info/edit'
      fullPath: '/clients/$clientId/corporate-info/edit'
      preLoaderRoute: typeof DashboardClientsClientIdCorporateInfoEditRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/identification/histories/$historyId': {
      id: '/_dashboard/clients/$clientId/identification/histories/$historyId'
      path: '/clients/$clientId/identification/histories/$historyId'
      fullPath: '/clients/$clientId/identification/histories/$historyId'
      preLoaderRoute: typeof DashboardClientsClientIdIdentificationHistoriesHistoryIdRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardBlacklistingRequestsNewRoute: typeof DashboardBlacklistingRequestsNewRoute
  DashboardClientsCreateRoute: typeof DashboardClientsCreateRoute
  DashboardContinuousPaymentPortoutRequestsCancelRoute: typeof DashboardContinuousPaymentPortoutRequestsCancelRoute
  DashboardContinuousPaymentPortoutRequestsNewRoute: typeof DashboardContinuousPaymentPortoutRequestsNewRoute
  DashboardDeliveryRequestsCreateRoute: typeof DashboardDeliveryRequestsCreateRoute
  DashboardPortoutRequestsCancelRoute: typeof DashboardPortoutRequestsCancelRoute
  DashboardPortoutRequestsNewRoute: typeof DashboardPortoutRequestsNewRoute
  DashboardBillingManagementIndexRoute: typeof DashboardBillingManagementIndexRoute
  DashboardBillingIndexRoute: typeof DashboardBillingIndexRoute
  DashboardBlacklistingRequestsIndexRoute: typeof DashboardBlacklistingRequestsIndexRoute
  DashboardCallDetailsIndexRoute: typeof DashboardCallDetailsIndexRoute
  DashboardClientsIndexRoute: typeof DashboardClientsIndexRoute
  DashboardContinuousPaymentConfirmationIndexRoute: typeof DashboardContinuousPaymentConfirmationIndexRoute
  DashboardContinuousPaymentPortoutRequestsIndexRoute: typeof DashboardContinuousPaymentPortoutRequestsIndexRoute
  DashboardDeliveryRequestsIndexRoute: typeof DashboardDeliveryRequestsIndexRoute
  DashboardIdentificationsIndexRoute: typeof DashboardIdentificationsIndexRoute
  DashboardNttpcMaintenancesIndexRoute: typeof DashboardNttpcMaintenancesIndexRoute
  DashboardOwnershipTransferIndexRoute: typeof DashboardOwnershipTransferIndexRoute
  DashboardPortoutRequestsIndexRoute: typeof DashboardPortoutRequestsIndexRoute
  DashboardSearchIndexRoute: typeof DashboardSearchIndexRoute
  DashboardSimDistributionIndexRoute: typeof DashboardSimDistributionIndexRoute
  DashboardClientsClientIdSimBindingRoute: typeof DashboardClientsClientIdSimBindingRoute
  DashboardDeliveryRequestsIdShippingHistoryRoute: typeof DashboardDeliveryRequestsIdShippingHistoryRoute
  DashboardClientsClientIdIndexRoute: typeof DashboardClientsClientIdIndexRoute
  DashboardClientsClientIdCorporateInfoEditRoute: typeof DashboardClientsClientIdCorporateInfoEditRoute
  DashboardClientsClientIdIdentificationEditRoute: typeof DashboardClientsClientIdIdentificationEditRoute
  DashboardClientsClientIdIdentificationReuploadRoute: typeof DashboardClientsClientIdIdentificationReuploadRoute
  DashboardClientsClientIdInvoicesInvoiceIdRoute: typeof DashboardClientsClientIdInvoicesInvoiceIdRoute
  DashboardClientsClientIdInvoicesIndexRoute: typeof DashboardClientsClientIdInvoicesIndexRoute
  DashboardClientsClientIdIdentificationHistoriesHistoryIdRoute: typeof DashboardClientsClientIdIdentificationHistoriesHistoryIdRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardBlacklistingRequestsNewRoute: DashboardBlacklistingRequestsNewRoute,
  DashboardClientsCreateRoute: DashboardClientsCreateRoute,
  DashboardContinuousPaymentPortoutRequestsCancelRoute:
    DashboardContinuousPaymentPortoutRequestsCancelRoute,
  DashboardContinuousPaymentPortoutRequestsNewRoute:
    DashboardContinuousPaymentPortoutRequestsNewRoute,
  DashboardDeliveryRequestsCreateRoute: DashboardDeliveryRequestsCreateRoute,
  DashboardPortoutRequestsCancelRoute: DashboardPortoutRequestsCancelRoute,
  DashboardPortoutRequestsNewRoute: DashboardPortoutRequestsNewRoute,
  DashboardBillingManagementIndexRoute: DashboardBillingManagementIndexRoute,
  DashboardBillingIndexRoute: DashboardBillingIndexRoute,
  DashboardBlacklistingRequestsIndexRoute:
    DashboardBlacklistingRequestsIndexRoute,
  DashboardCallDetailsIndexRoute: DashboardCallDetailsIndexRoute,
  DashboardClientsIndexRoute: DashboardClientsIndexRoute,
  DashboardContinuousPaymentConfirmationIndexRoute:
    DashboardContinuousPaymentConfirmationIndexRoute,
  DashboardContinuousPaymentPortoutRequestsIndexRoute:
    DashboardContinuousPaymentPortoutRequestsIndexRoute,
  DashboardDeliveryRequestsIndexRoute: DashboardDeliveryRequestsIndexRoute,
  DashboardIdentificationsIndexRoute: DashboardIdentificationsIndexRoute,
  DashboardNttpcMaintenancesIndexRoute: DashboardNttpcMaintenancesIndexRoute,
  DashboardOwnershipTransferIndexRoute: DashboardOwnershipTransferIndexRoute,
  DashboardPortoutRequestsIndexRoute: DashboardPortoutRequestsIndexRoute,
  DashboardSearchIndexRoute: DashboardSearchIndexRoute,
  DashboardSimDistributionIndexRoute: DashboardSimDistributionIndexRoute,
  DashboardClientsClientIdSimBindingRoute:
    DashboardClientsClientIdSimBindingRoute,
  DashboardDeliveryRequestsIdShippingHistoryRoute:
    DashboardDeliveryRequestsIdShippingHistoryRoute,
  DashboardClientsClientIdIndexRoute: DashboardClientsClientIdIndexRoute,
  DashboardClientsClientIdCorporateInfoEditRoute:
    DashboardClientsClientIdCorporateInfoEditRoute,
  DashboardClientsClientIdIdentificationEditRoute:
    DashboardClientsClientIdIdentificationEditRoute,
  DashboardClientsClientIdIdentificationReuploadRoute:
    DashboardClientsClientIdIdentificationReuploadRoute,
  DashboardClientsClientIdInvoicesInvoiceIdRoute:
    DashboardClientsClientIdInvoicesInvoiceIdRoute,
  DashboardClientsClientIdInvoicesIndexRoute:
    DashboardClientsClientIdInvoicesIndexRoute,
  DashboardClientsClientIdIdentificationHistoriesHistoryIdRoute:
    DashboardClientsClientIdIdentificationHistoriesHistoryIdRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface EkycRouteChildren {
  EkycResultRoute: typeof EkycResultRoute
  EkycErrorClientIdRoute: typeof EkycErrorClientIdRoute
  EkycSuccessClientIdRoute: typeof EkycSuccessClientIdRoute
}

const EkycRouteChildren: EkycRouteChildren = {
  EkycResultRoute: EkycResultRoute,
  EkycErrorClientIdRoute: EkycErrorClientIdRoute,
  EkycSuccessClientIdRoute: EkycSuccessClientIdRoute,
}

const EkycRouteWithChildren = EkycRoute._addFileChildren(EkycRouteChildren)

interface PaymentRouteChildren {
  PaymentCardRegisterTokenRoute: typeof PaymentCardRegisterTokenRoute
}

const PaymentRouteChildren: PaymentRouteChildren = {
  PaymentCardRegisterTokenRoute: PaymentCardRegisterTokenRoute,
}

const PaymentRouteWithChildren =
  PaymentRoute._addFileChildren(PaymentRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
  EkycRoute: EkycRouteWithChildren,
  LoginRoute: LoginRoute,
  MaintenanceRoute: MaintenanceRoute,
  PaymentRoute: PaymentRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
